export default {"src":"/_next/static/media/url-doc-teal.d9c1f843.svg","height":40,"width":40};